module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-21.5ff48bbb.png";